import { clsx } from 'clsx';
import { Explainer } from './Explainer';

const ACCENTS = {
  green: 'border-l-gat-green',
  greenBright: 'border-l-gat-greenBright',
  amber: 'border-l-status-budget',
  blue: 'border-l-status-open',
  red: 'border-l-status-lost',
  gray: 'border-l-text-empty',
};

const DELTA_TONES = {
  good: 'text-gat-green',
  bad: 'text-status-lost',
  neutral: 'text-text-muted',
};

export function KpiCard({ label, value, delta, deltaTone = 'good', accent = 'green', className, explain }) {
  return (
    <div
      className={clsx('bg-surface border border-border rounded-md px-4 py-3.5 shadow-sm border-l-[3px]', ACCENTS[accent], className)}
      style={{ position: 'relative', overflow: 'visible' }}
    >
      <div className="text-kpi-label uppercase text-text-muted flex items-center justify-between">
        <span>{label}</span>
        {explain && (
          <Explainer title={explain.title || label} formula={explain.formula} align="right">
            {explain.body}
          </Explainer>
        )}
      </div>
      <div className="text-kpi-val tabular-nums text-text-dark mt-1">{value}</div>
      {delta && <div className={clsx('text-[11px] font-semibold mt-0.5 tabular-nums', DELTA_TONES[deltaTone])}>{delta}</div>}
    </div>
  );
}
